import React from 'react'

const InfoMessage = ({ info }) => {
  return (
    <>
        {
			info ?
				<div className='info'>
					{ info }
				</div>
			: ''
		}
    </>
  )
}

export default InfoMessage